module.exports = __webpack_public_path__ + "img/why-ai-agents-break-in-production.6511e706.webp";